import { Side } from '@/compiled_proto/com/celertech/marketdata/api/enums/SideProto';
import cn from 'classnames';

interface DividerProps {
    side?: Side;
    className?: string;
    neutral?: boolean;
}

const Divider = ({ side, className, neutral = true }: DividerProps) => (
    <hr
        className={cn('w-full border-none h-[1px] m-0 flex-shrink-0', className, {
            ['bg-brand-border']: !className && (side === Side.BUY || !side) && !neutral,
            ['bg-brand-red']: !className && side === Side.SELL && !neutral,
            ['bg-brand-neutral-700']: neutral
        })}
    />
);

export default Divider;
